import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeForAlbumPurchaseIdentities } from '../../graphql/queries/account';
import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';
import { checkout as checkoutMutation } from '../../graphql/mutations/checkout';
import { checkoutPrice } from '../../graphql/queries/checkout';
import PurchaseAlbumCheckout from '../../components/purchase/PurchaseAlbumCheckout';
import {
  selectIdentityForPurchase,
  selectIdentityForJoin,
  deselectIdentityForPurchase,
  deselectIdentityForJoin,
  checkout,
} from '../../actions/purchase-album';
import {
  getPurchasedIdentities,
  getSelectedIdentities,
} from '../../util/account';
import { getCheckoutItemsForPurchase } from '../../util/purchase-album';
import { albumsJoinByCode } from '../../graphql/mutations/albums';
import { requestConfirm, openModal } from '../../actions/modal-actions';

const withUserData = graphql(MeForAlbumPurchaseIdentities, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
    },
  }),
  props: ({ data: { me }, ownProps: { match } }) => ({
    account: me,
    identities: me && me.linked_identities && me.linked_identities.records,
    purchasedIdentities: getPurchasedIdentities(me, match.params.albumId),
    joinedIdentities: getSelectedIdentities(me, match.params.albumId),
  }),
});

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

const withCheckout = graphql(checkoutMutation, {
  props: ({ mutate }) => ({
    checkout: (
      accountId,
      email,
      stripeToken,
      items,
      stripePaymentMethodId,
      stripeConnectAccountId,
    ) =>
      mutate({
        variables: {
          input: {
            account_id: accountId,
            email_address: email,
            stripe_token: stripeToken,
            subscription_items: items,
            platform: 'WEB',
            stripe_payment_method_id: stripePaymentMethodId,
            stripe_connect_account_id: stripeConnectAccountId,
          },
        },
      }),
  }),
});

const withAlbumsJoinByJoincode = graphql(albumsJoinByCode, {
  props: ({ mutate, ownProps: { album } }) => ({
    albumJoinByCode: (accountId, identities) =>
      mutate({
        variables: {
          input: {
            account_id: accountId,
            identities,
            join_codes: [album.join_code],
          },
        },
      }),
  }),
});

const withCheckoutPrice = graphql(checkoutPrice, {
  options: ({ selectedIdentitiesForPurchase, album, account }) => ({
    variables: {
      account_id: account?.id,
      subscription_items: getCheckoutItemsForPurchase(
        selectedIdentitiesForPurchase,
        album,
      ),
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { checkoutPrice: price, loading, error } }) => ({
    loadingPrice: loading,
    price,
    errorLoadingPrice: error,
  }),
  skip: ({ account, album }) => !album || !account,
});

const mapStateToProps = ({ purchaseAlbum }) => ({
  selectedIdentitiesForPurchase: purchaseAlbum.identitiesForPurchase,
  selectedIdentitiesForJoin: purchaseAlbum.identitiesForJoin,
  loading: purchaseAlbum.loading,
  error: purchaseAlbum.error,
  success: purchaseAlbum.success,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectIdentityForPurchase: identity =>
    dispatch(selectIdentityForPurchase(identity)),
  selectIdentityForJoin: identity => dispatch(selectIdentityForJoin(identity)),
  deselectIdentityForPurchase: identity =>
    dispatch(deselectIdentityForPurchase(identity)),
  deselectIdentityForJoin: identity =>
    dispatch(deselectIdentityForJoin(identity)),
  openModal: (...args) => dispatch(openModal(...args)),
  onCheckout: async ({
    accountId,
    email,
    stripeToken,
    joinItems,
    purchaseItems,
    stripePaymentMethodId,
    stripeConnectAccountId,
  }) => {
    await checkout({
      accountId,
      email,
      stripeToken,
      joinItems,
      purchaseItems,
      dispatch,
      checkoutMutation: ownProps.checkout,
      albumJoinByCodeMutation: ownProps.albumJoinByCode,
      stripePaymentMethodId,
      stripeConnectAccountId,
    });
  },
  requestConfirm: (...args) => dispatch(requestConfirm(...args)),
});

export default compose(
  withRouter,
  withUserData,
  withAlbumData,
  withCheckout,
  withAlbumsJoinByJoincode,
  connect(mapStateToProps, mapDispatchToProps),
  withCheckoutPrice,
)(PurchaseAlbumCheckout);
